export default {
    lang: {
        name: 'User rating'
    }
}